import { connect } from 'react-redux';
//@ts-expect-error untyped file
import { getCurrentThreadId } from '../selectors/getCurrentThreadId';
// @ts-expect-error untyped file
import { getSenderFromMessageSenders } from 'conversations-visitor-message-history/common-message/operators/getSenderFromMessageSenders';
import getIn from 'transmute/getIn';
import { TYPING_MESSAGE_STYLE } from 'conversations-message-history/typing-indicator/records/TypingIndicatorMessage';
const mapStateToProps = (state, props) => {
  const {
    message,
    senders
  } = props;
  const threadId = getCurrentThreadId(state);
  const sender = getSenderFromMessageSenders(message, senders);
  const senderId = getIn(['id'], sender);
  const style = getIn(['typingIndicatorStyle', threadId, senderId, 'style'], state) || TYPING_MESSAGE_STYLE.TYPING;
  return {
    style
  };
};
const mapDispatchToProps = {};
export const withTypingIndicatorStyle = connect(mapStateToProps, mapDispatchToProps);